// Mapping of set IDs to their BrickLink Designer Program page URLs.
// These sets link to BrickLink instead of LEGO.com.
// To add a new set: add a line with "setId": "https://www.bricklink.com/v3/designer-program/..."
// Note: the slug in the URL doesn't matter, BrickLink redirects based on the numeric ID.

const bricklinkDesignerProgram = {
  // BDP Invitational (2021-2023)
  "910001": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215665/Castle-in-the-Forest",
  "910002": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215385/Studgate-Train-Station",
  "910003": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215752/Mountain-Windmill",
  "910004": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215673/Winter-Chalet",
  "910008": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215744/Modular-Construction-Site",
  "910009": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215728/Modular-LEGO-Store",
  "910010": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215684/Great-Fishing-Boat",
  "910011": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215339/1950s-Diner",
  "910013": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215741/Retro-Bowling-Alley",
  "910015": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215751/Clockwork-Aquarium",
  "910016": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215755/Sheriffs-Safe",
  "910017": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215480/Kakapo",
  "910023": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215680/Venetian-Houses",
  "910027": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215732/Mountain-View-Observatory",
  "910028": "https://www.bricklink.com/v3/designer-program/designer-sets-for-adult-fans-of-lego/215724/Pursuit-of-Flight",

  // BDP Series 1
  "910029": "https://www.bricklink.com/v3/designer-program/series-1/482/Mountain-Fortress",
  "910030": "https://www.bricklink.com/v3/designer-program/series-1/29/Snack-Shack",
  "910031": "https://www.bricklink.com/v3/designer-program/series-1/10/General-Store",
  "910032": "https://www.bricklink.com/v3/designer-program/series-1/323/Parisian-Street",
  "910033": "https://www.bricklink.com/v3/designer-program/series-1/224/Old-Train-Engine-Shed",

  // BDP Series 2
  "910034": "https://www.bricklink.com/v3/designer-program/series-2/728/Brick-Cross",
  "910035": "https://www.bricklink.com/v3/designer-program/series-2/642/Logging-Railway",
  "910036": "https://www.bricklink.com/v3/designer-program/series-2/867/Ocean-House",
  "910037": "https://www.bricklink.com/v3/designer-program/series-2/824/Mushroom-House",
  "910038": "https://www.bricklink.com/v3/designer-program/series-2/734/Ominous-Isle",

  // BDP Series 3
  "910039": "https://www.bricklink.com/v3/designer-program/series-3/982/The-Art-of-Chocolate",
  "910040": "https://www.bricklink.com/v3/designer-program/series-3/962/Harbormasters-Office",
  "910041": "https://www.bricklink.com/v3/designer-program/series-3/1017/Camping-Adventure",
  "910042": "https://www.bricklink.com/v3/designer-program/series-3/1166/Lost-City",
  "910043": "https://www.bricklink.com/v3/designer-program/series-3/1127/Forest-Stronghold",

  // BDP Series 4
  "910044": "https://www.bricklink.com/v3/designer-program/series-4/1184/Wild-West-Train",
  "910045": "https://www.bricklink.com/v3/designer-program/series-4/1382/Siege-Encampment",
  "910046": "https://www.bricklink.com/v3/designer-program/series-4/1376/Merchant-Boat",
  "910047": "https://www.bricklink.com/v3/designer-program/series-4/1219/Medieval-Seaside-Market",
  "910048": "https://www.bricklink.com/v3/designer-program/series-4/1335/Riverside-Scholars",

  // BDP Series 5
  "910049": "https://www.bricklink.com/v3/designer-program/series-5/1821/Adventure-in-Transylvania",
  "910050": "https://www.bricklink.com/v3/designer-program/series-5/1688/Antique-Shop",
  "910051": "https://www.bricklink.com/v3/designer-program/series-5/1768/Mushroom-Village",
  "910052": "https://www.bricklink.com/v3/designer-program/series-5/1710/Popcorn-Wagon",
  "910053": "https://www.bricklink.com/v3/designer-program/series-5/1797/The-Thieves-of-Tortuga",

  // BDP Series 6
  "910054": "https://www.bricklink.com/v3/designer-program/series-6/1860/The-Art-Factory",
  "910055": "https://www.bricklink.com/v3/designer-program/series-6/2022/Gold-Mine-Expedition",
  "910056": "https://www.bricklink.com/v3/designer-program/series-6/1905/Off-road-Adventure",
  "910057": "https://www.bricklink.com/v3/designer-program/series-6/2123/Outlaw-Forest-Den",
  "910058": "https://www.bricklink.com/v3/designer-program/series-6/2109/Sequoia-Tree-Trail",

  // BDP Series 7 (set numbers TBD - add when assigned)
  // "??????": "https://www.bricklink.com/v3/designer-program/series-7/2447/Antique-Collection",
  // "??????": "https://www.bricklink.com/v3/designer-program/series-7/2667/Sushi-Restaurant",
  // "??????": "https://www.bricklink.com/v3/designer-program/series-7/2609/Privateer-Frigate-Fortuna",
  // "??????": "https://www.bricklink.com/v3/designer-program/series-7/2226/W.A.L.T.",
  // "??????": "https://www.bricklink.com/v3/designer-program/series-7/2557/Alchemists-Shop",
};

export default bricklinkDesignerProgram;
